/* eslint-disable @typescript-eslint/naming-convention -- campos snake_case espelham o schema do backend */

import { IActiveExecutionRaw } from './active-execution.interface';
import { AYA_STREAM_PROTOCOL, AyaStreamProtocol } from './stream-message-request.interface';

export enum EnumHITLDecisionType {
  APPROVE = 'approve',
  REJECT = 'reject'
}

export enum EnumHITLStatus {
  PENDING = 'pending',
  RESOLVED = 'resolved',
  CANCELLED = 'cancelled',
  NONE = 'none'
}

export enum EnumHITLErrorCode {
  NO_PENDING_INTERRUPT = 'no_pending_interrupt',
  STALE_INTERRUPT_ID = 'stale_interrupt_id',
  GENERATION_IN_PROGRESS = 'generation_in_progress',
  VALIDATION_ERROR = 'validation_error',
  SESSION_NOT_FOUND = 'session_not_found',
  INVALID_SESSION_ID = 'invalid_session_id',
  UNAUTHORIZED = 'unauthorized'
}

export interface IHITLInterruptError {
  code: EnumHITLErrorCode;
  message: string;
  execution?: IActiveExecutionRaw | null;
}

export interface IHITLActionRequest {
  name: string;
  args: Record<string, unknown>;
  description: string | null;
  payload_markdown?: string;
}

export interface IHITLReviewConfig {
  action_name: string;
  allowed_decisions: EnumHITLDecisionType[];
}

export interface IHITLRequest {
  action_requests: IHITLActionRequest[];
  activity_id?: string | null;
  review_configs: IHITLReviewConfig[];
  interrupt_id: string;
  status?: EnumHITLStatus;
  should_render?: boolean;
}

export interface ISessionState {
  status: 'paused' | 'active';
  should_render?: boolean;
  pending_interrupts: IHITLRequest[];
}

export interface IHITLConfirmationResponse {
  interrupt_id: string;
  decision: EnumHITLDecisionType;
  status: EnumHITLStatus;
  message: string | null;
}

export interface IHITLDecisionApprove {
  type: EnumHITLDecisionType.APPROVE;
}

export interface IHITLDecisionReject {
  type: EnumHITLDecisionType.REJECT;
  message?: string;
}

export type IHITLDecision = IHITLDecisionApprove | IHITLDecisionReject;

export interface IHITLResponse {
  decisions: IHITLDecision[];
  interrupt_id: string;
  stream_protocol: AyaStreamProtocol;
}

export const MAX_HITL_DECISIONS = 20;

export const MAX_HITL_DECISION_MESSAGE_LENGTH = 2000;

export const toHITLResponse = (
  interruptId: string,
  decisions: IHITLDecision[]
): IHITLResponse => ({
  decisions,
  interrupt_id: interruptId,
  stream_protocol: AYA_STREAM_PROTOCOL
});

/* eslint-enable @typescript-eslint/naming-convention */
